import { Host, h } from '@stencil/core';
export class AibaOptionSelection {
  constructor() {
    this.changeHandler = async (ev) => {
      const el = ev.target;
      this.selectedOption = el.checked ? el.value : '';
      console.log('select', this.selectedOption);
      if (this.handlers && this.handlers.handleOptionSelectedChangeHandler) {
        await this.handlers.handleOptionSelectedChangeHandler(ev, this.selectedOption);
      }
      // analyticsService.registerEvent('event2', ev);
      // this.ageRangeEventHandler(this.selectedAge);
      // if (isMobile()) {
      //  window.scrollTo({ top: 1000, behavior: 'smooth' });
      // } else {
      //  window.scrollTo({ top: 550, behavior: 'smooth' });
      // }
    };
    this.options = undefined;
    this.classes = undefined;
    this.handleClick = undefined;
    this.handlers = undefined;
    this.selectedOption = undefined;
  }
  render() {
    return (h(Host, null, h("div", { class: `option-selection-wrapper ${this.classes ? this.classes : ''}` }, this.options.map((option, index) => {
      return (h("div", { class: "input", key: index }, h("input", { type: "checkbox", id: option.id, name: "option", "aria-label": "option", class: "optionInput", value: option.value, checked: option.value === this.selectedOption, onChange: (ev) => this.changeHandler(ev) }), h("label", { htmlFor: option.id }, option.label)));
    }))));
  }
  static get is() { return "aiba-option-selection"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-option-selection.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-option-selection.css"]
    };
  }
  static get properties() {
    return {
      "options": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "options",
        "reflect": false
      },
      "classes": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "selectedOption": {}
    };
  }
}
//# sourceMappingURL=aiba-option-selection.js.map
